<template>
  <Modal v-if="show" :show="show" :close="close" max-width="1200" :show-dividers="false">
    <template #title>
      <v-row class="justify-end" no-gutters>
        <v-icon @click="close">mdi-close</v-icon>
      </v-row>
    </template>
    <template #text>
      <v-tabs v-model="currentTab" vertical>
        <v-tab v-for="(tab, index) in tabs" :key="`v-tab-header-${index}`" class="justify-start" :class="{'third--text': currentTab === index}">
          <v-icon left>{{ tab.icon }}</v-icon>
          <span>{{ tab.label }}</span>
        </v-tab>

        <v-tabs-slider color="red" />

        <v-tabs-items v-model="currentTab">
          <v-tab-item v-for="(tab, index) in tabs" :key="`v-tab-item-${index}`">
            <component
              v-if="index === currentTab || historyUpdated"
              :is="tab.component"
              :customer="customer"
              :contract="contract"
              @validity-updated="handleValidityUpdated"
              @history-changed="onHistoryChanged"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </template>
  </Modal>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import Modal from '@/components/common/Modal.vue';
import UpdateContractValidity from './UpdateContractValidity.vue';
import ContractValidityHistory from './ContractValidityHistory.vue';

export default {
  components: { Modal, UpdateContractValidity, ContractValidityHistory },
  props: {
    show: { type: Boolean, default: false },
    order: { type: Object, default: null },
    customer: { type: Object, default: null },
    onClose: { type: Function, default: null },
    onValidityUpdated: { type: Function, default: null }
  },
  setup (props) {
    const currentTab = ref(0);
    const historyUpdated = ref(false);

    const tabs = [
      { icon: 'mdi-plus-circle-outline', label: 'Mettre à jour contrat validité', component: 'UpdateContractValidity' },
      { icon: 'mdi-note-edit-outline', label: 'Historique des modifications', component: 'ContractValidityHistory' }
    ];

    const contract = computed(() => {
      if (!props.order || !props.customer) return null;
      const orderItem = props.order.order.order_items.find(item => item.customer.uuid === props.customer.uuid);
      if (!orderItem) return null;
      return orderItem.contract ? { ...orderItem.contract, workspace: props.order.siteWorkspaceCode } : null;
    });

    const close = () => {
      currentTab.value = 0;
      if (props.onClose) props.onClose();
    };

    const handleValidityUpdated = (data) => {
      if (props.onValidityUpdated) props.onValidityUpdated(data);
    };

    const onHistoryChanged = () => {
      historyUpdated.value = !historyUpdated.value;
    };

    return { currentTab, tabs, contract, historyUpdated, close, handleValidityUpdated, onHistoryChanged };
  }
};
</script>
